import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
import { showError} from "../utils/toast";

const PolicySubscription = () => {
    const [billingCycle, setBillingCycle] = useState("yearly");
    const navigate = useNavigate();

    const pricingPlans = [
        {
            id: 1,
            name: "Basic Plan",
            monthlyPrice: "299",
            yearlyPrice: "2,999",
            color: "basic",
            featuresMonth: [
                { text: "100 Policies/month", included: true },
                { text: "2 GB Storage", included: true },
                { text: "SMS (Paid)", included: true },
                { text: "Chat Support", included: true },
                { text: "Demo Access", included: true },
                { text: "Automation", included: true },
                { text: "Dashboard Access", included: true },
                { text: "Advanced Reports", included: false },
                { text: "Phone Support", included: false },
            ],
            featuresYear: [
                { text: "100 Policies/year", included: true },
                { text: "2 GB Storage", included: true },
                { text: "SMS (Paid)", included: true },
                { text: "Chat Support", included: true },
                { text: "Demo Access", included: true },
                { text: "Automation", included: true },
                { text: "Dashboard Access", included: true },
                { text: "Advanced Reports", included: false },
                { text: "Phone Support", included: false },
            ],
            popular: false,
        },
        {
            id: 2,
            name: "Premium Plan",
            monthlyPrice: "499",
            yearlyPrice: "4,999",
            color: "premium",
            featuresMonth: [
                { text: "500 Policies/month", included: true },
                { text: "4 GB Storage", included: true },
                { text: "SMS (Unlimited)", included: true },
                { text: "Priority Email Support", included: true },
                { text: "Advanced Reports", included: true },
                { text: "Dashboard", included: true },
                { text: "Phone Support", included: true },
                { text: "Priority Support 24/7", included: false },
            ],
            featuresYear: [
                { text: "500 Policies/year", included: true },
                { text: "4 GB Storage", included: true },
                { text: "SMS (Unlimited)", included: true },
                { text: "Priority Email Support", included: true },
                { text: "Advanced Reports", included: true },
                { text: "Dashboard", included: true },
                { text: "Phone Support", included: true },
                { text: "Priority Support 24/7", included: false },
            ],
            popular: true,
        },
        {
            id: 3,
            name: "Pro Plan",
            monthlyPrice: "599",
            yearlyPrice: "5,999",
            color: "pro",
            featuresMonth: [
                { text: "1000 Policies/month", included: true },
                { text: "8 GB Storage", included: true },
                { text: "SMS (Unlimited)", included: true },
                { text: "Phone + Email Support", included: true },
                { text: "Custom Reports", included: true },
                { text: "Dashboard", included: true },
                { text: "Advanced Reports", included: true },
                { text: "Priority Support 24/7", included: true },
            ],
            featuresYear: [
                { text: "1000 Policies/year", included: true },
                { text: "8 GB Storage", included: true },
                { text: "SMS (Unlimited)", included: true },
                { text: "Phone + Email Support", included: true },
                { text: "Custom Reports", included: true },
                { text: "Dashboard", included: true },
                { text: "Advanced Reports", included: true },
                { text: "Priority Support 24/7", included: true },
            ],
            popular: false,
        },
    ];

    return (
        <>
            <Header />
            <div className="policy-subscription">
                <div className="overlay-sub"></div>
                {/* Header Section */}
                <div className="subscription-header mt-5">
                    <h1 className="main-title">
                        <span className="quotation-text">Pricing</span>
                    </h1>
                    <p className="subtitle">
                        Insurance Management Platform Subscription Plans
                    </p>
                </div>

                {/* Billing Toggle */}
                <div className="billing-toggle">
                    <button
                        className={`toggle-btn ${billingCycle === "monthly" ? "active" : ""
                            }`}
                        onClick={() => setBillingCycle("monthly")}
                    >
                        Monthly
                    </button>
                    <button
                        className={`toggle-btn ${billingCycle === "yearly" ? "active" : ""
                            }`}
                        onClick={() => setBillingCycle("yearly")}
                    >
                        Yearly
                        <span className="save-badge">Save 17%</span>
                    </button>
                </div>

                {/* Pricing Section Title */}
                <div className="pricing-intro">
                    <h2>Choose Our Competitive Pricing Plan as Suitable you</h2>
                </div>

                {/* Pricing Cards */}
                <div className="pricing-container">
                    {pricingPlans.map((plan) => {
                        // Get the correct features based on billing cycle
                        const currentFeatures = billingCycle === "monthly"
                            ? plan.featuresMonth
                            : plan.featuresYear;

                        return (
                            <div
                                key={plan.id}
                                className={`pricing-card ${plan.color} ${plan.popular ? "popular" : ""
                                    }`}
                            >
                                {plan.popular && (
                                    <div className="popular-badge">Most Popular</div>
                                )}

                                <div className="card-header">
                                    <h3 className="plan-name">{plan.name}</h3>
                                    <div className="price-section">
                                        <span className="currency">₹</span>
                                        <span className="price">
                                            {billingCycle === "monthly"
                                                ? plan.monthlyPrice
                                                : plan.yearlyPrice}
                                        </span>
                                        <span className="period">
                                            /{billingCycle === "monthly" ? "month" : "year"}
                                        </span>
                                    </div>
                                    {billingCycle === "yearly" ?
                                        <p className="billing-note">Billed annually</p> :
                                        <p className="billing-note">Billed monthly</p>
                                    }
                                </div>

                                <div className="card-body">
                                    <ul className="features-list">
                                        {currentFeatures.map((feature, index) => (
                                            <li
                                                key={index}
                                                className={`feature-item ${feature.included ? "included" : "not-included"
                                                    }`}
                                            >
                                                <span className="check-icon">
                                                    {feature.included ? "✓" : "✗"}
                                                </span>
                                                <span className="feature-text">{feature.text}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="card-footer">
                                    <button
                                        className={`subscribe-btn ${plan.color}`}
                                        onClick={() => {
                                            navigate("/register");
                                            showError("Please complete registration first.");
                                        }}
                                    >
                                        {plan.popular ? "Get Started" : "Choose Plan"}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Additional Features Section */}
                <div className="additional-features">
                    <h3>Our Features & Services</h3>
                    <div className="features-grid">
                        <div className="feature-badge">
                            <span className="badge-icon">📋</span>
                            Life Insurance Management
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">🏥</span>
                            General Insurance Management
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">📈</span>
                            Investment Management
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">⭐</span>
                            Business & Review Facility
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">📱</span>
                            Client Mobile Application
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">💬</span>
                            WhatsApp Message
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">📧</span>
                            E-Mail Message/Alerts
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">💌</span>
                            Greeting SMS
                        </div>
                        <div className="feature-badge">
                            <span className="badge-icon">📊</span>
                            Business SMS
                        </div>
                    </div>
                </div>

                {/* Footer Note */}
                <div className="subscription-footer pb-3 m-4">
                    <p className="contact-info">
                        For custom enterprise solutions, contact us at{" "}
                        <a href="mailto:support@policysaath.com">
                            support@policysaath.com
                        </a>
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PolicySubscription;